// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@keyframes ink-enter {
  from {
    opacity: 0;
    transform: translateY(8px);
  }
  to {
    opacity: 1;
    transform: none;
  }
}
.papers-view-overlay {
  position: fixed;
  inset: 0;
  z-index: 10000;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.6);
  font-family: "Din-pro", "Segoe UI", system-ui, sans-serif;
}

.papers-view-prompt {
  font-family: "Din-pro", "Segoe UI", system-ui, sans-serif;
  color: #ebe8e1;
  background: rgba(11, 15, 19, 0.96);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 6px;
  box-shadow: 0 18px 50px rgba(0, 0, 0, 0.6);
  backdrop-filter: blur(6px);
  animation: ink-enter 0.16s ease-out;
  width: min(420px, 92%);
  padding: 20px 22px 18px;
  text-align: left;
}
.papers-view-prompt * {
  box-sizing: border-box;
}
@media (prefers-reduced-motion: reduce) {
  .papers-view-prompt {
    animation: none;
  }
}
.papers-view-prompt-title {
  font-family: "Marcellus", "Cinzel", Georgia, serif;
  font-weight: 400;
  font-size: 22px;
  line-height: 1.15;
  letter-spacing: 0.01em;
  color: #ebe8e1;
  margin-bottom: 10px;
}
.papers-view-prompt-text {
  margin: 0;
  font-size: 15px;
  line-height: 1.5;
  color: #ebe8e1;
}
.papers-view-prompt-text strong {
  font-weight: 600;
  color: var(--gold-light);
}
.papers-view-prompt-actions {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  margin-top: 18px;
}

.papers-view-card {
  font-family: "Din-pro", "Segoe UI", system-ui, sans-serif;
  color: #ebe8e1;
  background: rgba(11, 15, 19, 0.96);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 6px;
  box-shadow: 0 18px 50px rgba(0, 0, 0, 0.6);
  backdrop-filter: blur(6px);
  animation: ink-enter 0.16s ease-out;
  position: relative;
  width: min(420px, 92%);
  padding: 20px 22px 22px;
  border-top: 4px solid var(--gold-main);
  text-align: left;
}
.papers-view-card * {
  box-sizing: border-box;
}
@media (prefers-reduced-motion: reduce) {
  .papers-view-card {
    animation: none;
  }
}
.papers-view-card--empire {
  border-top-color: #b45050;
}
.papers-view-card--thalmor {
  border-top-color: #8d8a82;
}
.papers-view-card-from {
  font-size: 13px;
  line-height: 1.5;
  color: #8d8a82;
  margin-bottom: 10px;
}
.papers-view-card-label {
  font-family: "Marcellus", "Cinzel", Georgia, serif;
  font-weight: 400;
  font-size: 20px;
  line-height: 1.15;
  letter-spacing: 0.01em;
  color: #ebe8e1;
  margin-bottom: 10px;
}
.papers-view-card-holder {
  font-size: 17px;
  font-weight: 600;
  color: #ebe8e1;
  margin-bottom: 2px;
}
.papers-view-card-date {
  font-size: 14px;
  color: #aeaba2;
}
.papers-view-card-status {
  margin-top: 14px;
  font-size: 14px;
  font-weight: 600;
  color: #8fbf8a;
}
.papers-view-card-status--fake {
  color: #d9786d;
}
.papers-view-card-bounties {
  margin-top: 14px;
  padding-top: 12px;
  border-top: 1px solid rgba(255, 255, 255, 0.12);
}
.papers-view-card-bounty {
  font-size: 14px;
  color: #d9786d;
}
.papers-view-card-bounty + .papers-view-card-bounty {
  margin-top: 4px;
}
.papers-view-card-close {
  display: flex;
  margin: 18px 0 0 auto;
}

.papers-view-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 8px 14px;
  font-family: "Din-pro", "Segoe UI", system-ui, sans-serif;
  font-size: 14px;
  font-weight: 600;
  line-height: 1.2;
  white-space: nowrap;
  color: #ebe8e1;
  background: rgba(255, 255, 255, 0.07);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 6px;
  cursor: pointer;
  transition: background-color 0.12s ease, border-color 0.12s ease, color 0.12s ease;
}
.papers-view-btn:hover:not(:disabled) {
  background: rgba(255, 255, 255, 0.12);
  border-color: var(--gold-dark);
}
.papers-view-btn:active:not(:disabled) {
  transform: translateY(1px);
}
.papers-view-btn:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}
.papers-view-btn:focus-visible {
  outline: 2px solid var(--gold-light);
  outline-offset: 2px;
}
.papers-view-btn--cancel {
  color: #ebe8e1;
}
.papers-view-btn--confirm {
  color: #14100a;
  background: var(--gold-main);
  border-color: var(--gold-main);
}
.papers-view-btn--confirm:hover:not(:disabled) {
  background: var(--gold-light);
  border-color: var(--gold-light);
}`, "",{"version":3,"sources":["webpack://./src/theme/_ink.scss","webpack://./src/features/papersShow/styles.scss"],"names":[],"mappings":"AAmLA;EACE;IAAO,UAAA;IAAY,0BAAA;EChLnB;EDiLA;IAAO,UAAA;IAAY,eAAA;EC7KnB;AACF;AAFA;EACE,eAAA;EACA,QAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,8BAAA;EACA,yDDeU;ACXZ;;AAAA;EDcE,yDAHU;EAIV,cAbK;EAoBL,kCAzBI;EA0BJ,0CAAA;EACA,kBAjBO;EAkBP,0CAAA;EACA,0BAAA;EAiIA,mCAAA;ECxJA,sBAAA;EACA,uBAAA;EACA,gBAAA;AASF;ADEE;EAAI,sBAAA;ACCN;AD4IE;EC7JF;ID6J4C,eAAA;ECxI1C;AACF;AAfE;ED8BA,kDA3BW;EA4BX,gBAAA;EACA,eChC6B;EDiC7B,iBAAA;EACA,sBAAA;EACA,cAxCK;ECK+B,mBAAA;AAwBtC;AAtBE;EACE,SAAA;EACA,eAAA;EACA,gBAAA;EACA,cDXG;ACmCP;AAtBI;EAAS,gBAAA;EAAkB,wBAAA;AA0B/B;AAvBE;EACE,aAAA;EACA,yBAAA;EACA,QAAA;EACA,gBAAA;AAyBJ;;AApBA;EDbE,yDAHU;EAIV,cAbK;EAoBL,kCAzBI;EA0BJ,0CAAA;EACA,kBAjBO;EAkBP,0CAAA;EACA,0BAAA;EAiIA,mCAAA;EC7HA,kBAAA;EACA,sBAAA;EACA,uBAAA;EACA,sCAAA;EACA,gBAAA;AA6BF;AD/CE;EAAI,sBAAA;ACkDN;AD2FE;EClIF;IDkI4C,eAAA;ECvF1C;AACF;AAnCE;EAAY,yBAnDE;AAyFhB;AArCE;EAAa,yBAnDE;AA2FjB;AAtCE;EDaA,eAAA;EACA,gBAAA;EACA,cAlDO;ECqCL,mBAAA;AA0CJ;AAvCE;EDPA,kDA3BW;EA4BX,gBAAA;EACA,eCMqB;EDLrB,iBAAA;EACA,sBAAA;EACA,cAxCK;EC4CH,mBAAA;AA8CJ;AA3CE;EACE,eAAA;EACA,gBAAA;EACA,cDlDG;ECmDH,kBAAA;AA6CJ;AA1CE;EACE,eAAA;EACA,cDvDK;ACmGT;AAzCE;EACE,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,cD3DM;ACsGV;AAzCI;EAAU,cD9DL;AC0GT;AAzCE;EACE,gBAAA;EACA,iBAAA;EACA,+CAAA;AA2CJ;AAxCE;EACE,eAAA;EACA,cDzEK;ACmHT;AAxCI;EAAQ,eAAA;AA2CZ;AAxCE;EACE,aAAA;EACA,qBAAA;AA0CJ;;AAtCA;EDxBE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,iBAAA;EACA,yDA3DU;EA4DV,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAzEK;EA0EL,qCAAA;EACA,0CAAA;EACA,kBAvEO;EAwEP,eAAA;EACA,kFAAA;ACkEF;ADhEE;EAAyB,qCAAA;EAAuC,8BAAA;ACoElE;ADnEE;EAA0B,0BAAA;ACsE5B;ADrEE;EAAa,YAAA;EAAc,mBAAA;ACyE7B;ADxEE;EAAkB,oCAAA;EAAsC,mBAAA;AC4E1D;AApEE;EACE,cD5FG;ACkKP;AAnEE;EDRA,cAjFU;EAkFV,4BAAA;EACA,8BAAA;AC8EF;AD5EE;EAAyB,6BAAA;EAA+B,+BAAA;ACgF1D","sourcesContent":["// Shared look of the redesigned interfaces (escape menu, ALT menu, housing\n// drawer, and every other panel brought in line with them).\n//\n// Usage from any component stylesheet:\n//   @use '../../theme/ink' as ink;      // adjust the relative path\n//   .my-panel { @include ink.panel; }\n//\n// Rules the whole UI follows:\n//   - ink background, 1px light border, ONE corner radius (6px)\n//   - accent colour only through the palette tokens --gold-main/-light/-dark\n//     (never a hard-coded gold hex), so the palette picker keeps working\n//   - Marcellus for titles, Din-pro for everything else\n//   - no ornaments, no emoji, no centred decorative rules\n//   - hover and focus states on every control, reduced-motion respected\n//   - no color-mix() / relative colour syntax (older CEF in game)\n\n$ink: rgba(11, 15, 19, 0.96);\n$ink-raised: rgba(255, 255, 255, 0.04);\n$ink-field: rgba(0, 0, 0, 0.35);\n$line: rgba(255, 255, 255, 0.12);\n$line-strong: rgba(255, 255, 255, 0.2);\n$text: #ebe8e1;\n$text-2: #aeaba2;\n$text-3: #8d8a82;\n$danger: #d9786d;\n$success: #8fbf8a;\n$radius: 6px;\n$on-accent: #14100a;\n\n$font-title: 'Marcellus', 'Cinzel', Georgia, serif;\n$font-text: 'Din-pro', 'Segoe UI', system-ui, sans-serif;\n\n@mixin base {\n  font-family: $font-text;\n  color: $text;\n  * { box-sizing: border-box; }\n}\n\n// Floating panel (modals, centred prompts, docked windows).\n@mixin panel {\n  @include base;\n  background: $ink;\n  border: 1px solid $line-strong;\n  border-radius: $radius;\n  box-shadow: 0 18px 50px rgba(0, 0, 0, 0.6);\n  backdrop-filter: blur(6px);\n}\n\n// Raised block inside a panel.\n@mixin block {\n  background: $ink-raised;\n  border: 1px solid $line;\n  border-radius: $radius;\n}\n\n@mixin title($size: 22px) {\n  font-family: $font-title;\n  font-weight: 400;\n  font-size: $size;\n  line-height: 1.15;\n  letter-spacing: 0.01em;\n  color: $text;\n}\n\n@mixin lead {\n  font-size: 14px;\n  line-height: 1.5;\n  color: $text-2;\n}\n\n@mixin hint {\n  font-size: 13px;\n  line-height: 1.5;\n  color: $text-3;\n}\n\n@mixin label {\n  font-size: 13px;\n  font-weight: 600;\n  color: $text-2;\n}\n\n// Buttons: neutral by default; add the modifiers below for the other kinds.\n@mixin button {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  padding: 8px 14px;\n  font-family: $font-text;\n  font-size: 14px;\n  font-weight: 600;\n  line-height: 1.2;\n  white-space: nowrap;\n  color: $text;\n  background: rgba(255, 255, 255, 0.07);\n  border: 1px solid $line-strong;\n  border-radius: $radius;\n  cursor: pointer;\n  transition: background-color 0.12s ease, border-color 0.12s ease, color 0.12s ease;\n\n  &:hover:not(:disabled) { background: rgba(255, 255, 255, 0.12); border-color: var(--gold-dark); }\n  &:active:not(:disabled) { transform: translateY(1px); }\n  &:disabled { opacity: 0.4; cursor: not-allowed; }\n  &:focus-visible { outline: 2px solid var(--gold-light); outline-offset: 2px; }\n}\n\n@mixin button-primary {\n  color: $on-accent;\n  background: var(--gold-main);\n  border-color: var(--gold-main);\n\n  &:hover:not(:disabled) { background: var(--gold-light); border-color: var(--gold-light); }\n}\n\n@mixin button-danger {\n  color: $danger;\n  background: transparent;\n  border-color: rgba(217, 120, 109, 0.45);\n\n  &:hover:not(:disabled) { background: rgba(217, 120, 109, 0.14); border-color: $danger; }\n}\n\n@mixin button-quiet {\n  color: $text-3;\n  background: transparent;\n  border-color: transparent;\n\n  &:hover:not(:disabled) { color: $text; background: rgba(255, 255, 255, 0.07); border-color: transparent; }\n}\n\n@mixin button-sm {\n  padding: 5px 10px;\n  font-size: 13px;\n}\n\n@mixin field {\n  width: 100%;\n  padding: 9px 11px;\n  font-family: $font-text;\n  font-size: 14px;\n  color: $text;\n  background: $ink-field;\n  border: 1px solid $line-strong;\n  border-radius: $radius;\n  user-select: text;\n\n  &:focus { outline: none; border-color: var(--gold-main); }\n  &::placeholder { color: $text-3; font-family: $font-text; text-transform: none; letter-spacing: normal; opacity: 1; }\n}\n\n// Pill-shaped counters are the only rounded exception (small badges).\n@mixin badge {\n  display: inline-block;\n  min-width: 20px;\n  padding: 1px 7px;\n  font-size: 12px;\n  font-weight: 600;\n  text-align: center;\n  color: $text-2;\n  background: rgba(255, 255, 255, 0.09);\n  border-radius: 10px;\n}\n\n@mixin scroll {\n  overflow-y: auto;\n  scrollbar-width: thin;\n  scrollbar-color: rgba(255, 255, 255, 0.2) transparent;\n\n  &::-webkit-scrollbar { width: 6px; }\n  &::-webkit-scrollbar-thumb { background: rgba(255, 255, 255, 0.2); border-radius: 3px; }\n}\n\n@mixin enter($from: translateY(8px)) {\n  animation: ink-enter 0.16s ease-out;\n\n  @media (prefers-reduced-motion: reduce) { animation: none; }\n}\n\n@keyframes ink-enter {\n  from { opacity: 0; transform: translateY(8px); }\n  to   { opacity: 1; transform: none; }\n}\n\n// Tabs (underline style, as in the housing drawer).\n@mixin tab {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 9px 12px;\n  margin-bottom: -1px;\n  font-family: $font-text;\n  font-size: 14px;\n  font-weight: 600;\n  color: $text-2;\n  background: transparent;\n  border: 0;\n  border-bottom: 2px solid transparent;\n  cursor: pointer;\n\n  &:hover { color: $text; }\n  &:focus-visible { outline: 2px solid var(--gold-light); outline-offset: -2px; }\n}\n\n@mixin tab-active {\n  color: var(--gold-light);\n  border-bottom-color: var(--gold-main);\n}\n","@use '../../theme/ink' as ink;\n\n// Issuer accents for the card edge (identity of the issuing power, not the\n// palette accent).\n$empire-accent: #b45050;\n$thalmor-accent: #8d8a82;\n\n.papers-view-overlay {\n  position: fixed;\n  inset: 0;\n  z-index: 10000;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: rgba(0, 0, 0, 0.6);\n  font-family: ink.$font-text;\n}\n\n// \"X wants to show you their papers\" prompt.\n.papers-view-prompt {\n  @include ink.panel;\n  @include ink.enter;\n  width: min(420px, 92%);\n  padding: 20px 22px 18px;\n  text-align: left;\n\n  &-title { @include ink.title(22px); margin-bottom: 10px; }\n\n  &-text {\n    margin: 0;\n    font-size: 15px;\n    line-height: 1.5;\n    color: ink.$text;\n\n    strong { font-weight: 600; color: var(--gold-light); }\n  }\n\n  &-actions {\n    display: flex;\n    justify-content: flex-end;\n    gap: 8px;\n    margin-top: 18px;\n  }\n}\n\n// The document shown by someone else.\n.papers-view-card {\n  @include ink.panel;\n  @include ink.enter;\n  position: relative;\n  width: min(420px, 92%);\n  padding: 20px 22px 22px;\n  border-top: 4px solid var(--gold-main);\n  text-align: left;\n\n  &--empire { border-top-color: $empire-accent; }\n  &--thalmor { border-top-color: $thalmor-accent; }\n\n  &-from {\n    @include ink.hint;\n    margin-bottom: 10px;\n  }\n\n  &-label {\n    @include ink.title(20px);\n    margin-bottom: 10px;\n  }\n\n  &-holder {\n    font-size: 17px;\n    font-weight: 600;\n    color: ink.$text;\n    margin-bottom: 2px;\n  }\n\n  &-date {\n    font-size: 14px;\n    color: ink.$text-2;\n  }\n\n  &-status {\n    margin-top: 14px;\n    font-size: 14px;\n    font-weight: 600;\n    color: ink.$success;\n\n    &--fake { color: ink.$danger; }\n  }\n\n  &-bounties {\n    margin-top: 14px;\n    padding-top: 12px;\n    border-top: 1px solid ink.$line;\n  }\n\n  &-bounty {\n    font-size: 14px;\n    color: ink.$danger;\n\n    & + & { margin-top: 4px; }\n  }\n\n  &-close {\n    display: flex;\n    margin: 18px 0 0 auto;\n  }\n}\n\n.papers-view-btn {\n  @include ink.button;\n\n  // Dismiss action: neutral. (Class name kept from the old markup.)\n  &--cancel {\n    color: ink.$text;\n  }\n\n  &--confirm {\n    @include ink.button-primary;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
